import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { cn } from "@/lib/utils";
import { IForm } from "@/types";
import { CSSProperties } from "react";
import { useFormContext } from "react-hook-form";

interface Props {
    field: IForm["fields"][0];
    admin?: boolean;
    setSelectedField?: (field: IForm["fields"][0]) => void; // Allow setting selected field
    value?: string; // Optional value prop
    className?: string;
    style?: CSSProperties;
}

export const TextField = ({
    field,
    admin,
    setSelectedField,
    value,
    className,
    style,
}: Props) => {
    const formContext = useFormContext();
    const register = admin ? () => {} : formContext.register;
    const errors = admin ? {} : formContext.formState.errors;

    return (
        <div
            className={cn("flex w-full flex-col gap-1", className)}
            onClick={() => {
                if (admin && setSelectedField) {
                    setSelectedField(field); // Open item when admin clicks
                }
            }}
        >
            <Label variant="toggle" className="!text-form-primary-text-color">
                {field.question || (
                    <span className="text-form-primary-text-color/70">
                        Question goes here...
                    </span>
                )}
                {field.required && (
                    <span className="text-form-primary-color">*</span>
                )}
            </Label>
            {field.description && (
                <Label
                    variant="subtoggle"
                    className="text-form-primary-text-color/70"
                >
                    {field.description}
                </Label>
            )}

            {/* Input Field (Read-Only for Admin) */}
            <Input
                {...(!admin ? register(field.id) : {})}
                variant="card"
                placeholder={field.placeholder || "Answer..."}
                // className={`border-0 ${errors?.[field.id] ? "border-red-500" : ""}`}
                className={cn(
                    "border-0",
                    errors?.[field.id] ? "border-destructive" : "",
                    admin && "pointer-events-none",
                    "border-b-form-primary-color/30 focus:border-b-form-primary-color placeholder:text-form-primary-text-color/50 focus-visible:border-form-primary-color rounded-none border-b bg-transparent"
                )}
                readOnly={admin} // Allow click but prevent typing if admin
                value={value}
                // style={style}
            />

            {/* Validation Error Message (only for non-admin users) */}
            {!admin && errors?.[field.id] && (
                <p className="text-sm text-red-500">
                    {errors[field.id]?.message?.toString()}
                </p>
            )}
        </div>
    );
};
